/* eslint-disable react/prop-types */
import React from 'react';

import { ProblemStage, problemStageValue } from '../common/page-info';
import { TagScenario } from '../common-components/tag-scenario';
import { getImageUrlFromScenario } from '../common/helpers';
import { EvalData } from '../page-data/eval-data';
import { EvalTags } from '../common-components/eval-tags';
import { Grid } from '@mui/material';
import { noOp } from '../utils/utils';
import { Discourse } from '../common-components/discourse';
import Card from '@mui/material/Card';
import { PageComp } from './page-comp-props';
import { blue } from '@mui/material/colors';

//------------------------------------------------------------------------------
const PeerEval: PageComp = (props) => {
  const { isTeacherView, stage, onChange = noOp } = props;
  const pageData = props.pageData as EvalData;
  const { scenario, skill } = pageData;
  const skillName = skill.name.toLocaleLowerCase();
  const name = scenario?.metadata?.patient?.name;

  const instruction = (
    <div>
      <b>Read the dialogue</b> between the provider and {name} as well as an <b>example provider
      response at the end.</b> You will be asked to evaluate that example response against specific criteria.
    </div>
  );

  const tagInstructions = `The provider response should have the positive traits \
of ${skillName} listed below while avoiding negative ones. Evaluate the example provider \
answer for each one of them.`;

  const isProblemStageReached = (stageEval: ProblemStage) =>
    problemStageValue(stage) >= problemStageValue(stageEval);

  const onEvalChange = () => {
    onChange();
  };

  return (
    <Grid spacing='4' container direction='column'>
      <Grid item>
        <TagScenario
          imgUrl={getImageUrlFromScenario(scenario)}
          background={scenario?.metadata.patient.background}
          content={scenario?.content?.markdown || scenario?.content.text || ''}
          description={instruction}
        />
      </Grid>
      <Grid item>
        <Card>
          <Discourse isTeacherView={!!isTeacherView} pageData={pageData} problemStage={stage} />
          <Grid container sx={{ py: 1, backgroundColor: blue[50], padding: '0.5em' }}>
            <Grid item xs={1.2} sx={{ textAlign: 'left', minWidth: '5em' }}>
              <b>Provider Response:</b>
            </Grid>
            <Grid item xs={10.8}>
              <div>{pageData.firstResponse}</div>
            </Grid>
          </Grid>
        </Card>{' '}
      </Grid>
      {isProblemStageReached(ProblemStage.Evaluate) && (
        <Grid item>
          <EvalTags
            instructions={tagInstructions}
            pageData={pageData}
            onChange={onEvalChange}
          />
        </Grid>
      )}
    </Grid>
  );
};

//******************************************************************************
export const PeerEvalComp = PeerEval;
